import BizkeytechBroadcastService from "../../../@bizkeytech/base/core/services/broadcast";


export interface AuthenticationMiddlewareBroadcastListener {
    (arg: AuthenticationMiddlewareBroadcastArg): void;
}

export interface AuthenticationMiddlewareBroadcastArg {
    type: 'login-successful',
    payload?: any,
}


export interface PreviewContentBroadcastListener<Data = unknown> {
    (arg: PreviewContentReadyToReceiveBroadcastArg | PreviewContentDataSentBroadcastArg<Data> | PreviewContentResetBroadcastArg): void;
}

export interface PreviewContentReadyToReceiveBroadcastArg {
    type: 'ready-to-receive',
    payload: string,
}

export interface PreviewContentResetBroadcastArg {
    type: 'reset',
    payload: string,
}

export interface PreviewContentDataSentBroadcastArg<Data = unknown> {
    type: 'data-sent',
    payload: {
        token: string,
        data: Data,
    },
}


/**@inheritdoc*/
class BroadcastService extends BizkeytechBroadcastService {

    /**
     * The names of the channels that are used in the application.
     */
    public static readonly channelNames = {
        ...super.channelNames,
        authenticationMiddleware: 'authentication-middleware',
        previewContent: 'preview-content',
    }
}

export * from 'broadcast-channel';
export type * from '../../../@bizkeytech/base/core/services/broadcast';
export default BroadcastService;

